// src/Components/Modules/HR/AssetManager.js
import React, { useState, useEffect } from "react";
import { AxiosAuthInstance } from "../../../AxiosInterceptors";
import Breadcrumb from "../../Partials/Breadcrumb";
import { Table, Button, Badge, Message, toaster, Loader, Form, Input, SelectPicker } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import { FaStar, FaSave, FaPaperPlane } from "react-icons/fa";

const { Column, HeaderCell, Cell } = Table;

const PerformanceAppraisal = () => {
  const [appraisals, setAppraisals] = useState([]);
  const [form, setForm] = useState({ employee_id: "", period: "2026-Q2", self_rating: 0, goals_achieved: "" });
  const [loading, setLoading] = useState(false);
  const role = Number(localStorage.getItem("who_am_i"));

  useEffect(() => { fetch(); }, []);
  const fetch = () => AxiosAuthInstance.get("hr/performance").then(r => setAppraisals(r.data.data || r.data));

  const create = async () => {
    setLoading(true);
    try {
      await AxiosAuthInstance.post("hr/performance", form);
      toaster.push(<Message type="success">Draft created</Message>, { placement: "topEnd" });
      fetch();
    } catch { toaster.push(<Message type="error">Failed</Message>, { placement: "topEnd" }); }
    finally { setLoading(false); }
  };

  const submit = async (id) => { await AxiosAuthInstance.post(`hr/performance/${id}/submit`); fetch(); };
  const review = async (id, rating, feedback) => { await AxiosAuthInstance.put(`hr/performance/${id}`, { manager_rating: rating, manager_feedback: feedback }); fetch(); };

  return (
    <div className="p-3">
      <Breadcrumb title="Performance Management" />
      {role <= 2 && (
        <div className="card p-3 mb-3 shadow-sm">
          <h6>New Appraisal Draft</h6>
          <div className="row g-2">
            <div className="col-3"><Input type="number" placeholder="Employee ID" value={form.employee_id} onChange={v => setForm({...form, employee_id: v})} /></div>
            <div className="col-2"><Input value={form.period} onChange={v => setForm({...form, period: v})} /></div>
            <div className="col-2"><Input type="number" min="0" max="5" placeholder="Self Rating" value={form.self_rating} onChange={v => setForm({...form, self_rating: v})} /></div>
            <div className="col-3"><Input placeholder="Goals" value={form.goals_achieved} onChange={v => setForm({...form, goals_achieved: v})} /></div>
            <div className="col-2"><Button appearance="primary" block onClick={create} startIcon={<FaSave />}>Create</Button></div>
          </div>
        </div>
      )}
      <Table data={appraisals} height={500}>
        <Column width={150}><HeaderCell>Employee</HeaderCell><Cell>{r => r.employee?.employee_name}</Cell></Column>
        <Column width={100}><HeaderCell>Period</HeaderCell><Cell dataKey="period" /></Column>
        <Column width={100}><HeaderCell>Self</HeaderCell><Cell dataKey="self_rating" /></Column>
        <Column width={100}><HeaderCell>Manager</HeaderCell><Cell dataKey="manager_rating" /></Column>
        <Column width={100}><HeaderCell>Status</HeaderCell><Cell>{r => <Badge color={r.status==="reviewed"?"green":"orange"}>{r.status}</Badge>}</Cell></Column>
        <Column width={200}><HeaderCell>Action</HeaderCell>
          <Cell>{r => (
            <>
              {r.status === "draft" && <Button size="xs" color="blue" startIcon={<FaPaperPlane />} onClick={() => submit(r.id)}>Submit</Button>}
              {r.status === "submitted" && role <= 2 && <Button size="xs" color="green" onClick={() => { const f = prompt("Manager Rating (0-5):"); const fb = prompt("Feedback:"); review(r.id, f, fb); }}>Review</Button>}
            </>
          )}</Cell>
        </Column>
      </Table>
    </div>
  );
};
export default PerformanceAppraisal;